// YourOpportunities.js — BL-048 (ADR-068) dashboard panel.
//
// User-owned own-investor Opportunity Signals (N=1). Rendered ONLY from the
// server-authoritative panel (metrics.opportunities), which the server omits
// when the feature is off. Each row deep-links to the stable
// /my-analyses/:analysisId route. Signal-not-advice (ADR-044): this surfaces
// the user's OWN saved opportunities and carries a not-advice clarifier — no
// recommendation/advice language, distinct from BL-011 Market Signals.

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { analysisRoute, opportunityRows } from "../../lib/opportunities";
import { opportunityShownOnDashboard, opportunityOpened } from "../../lib/opportunityAnalytics";

export default function YourOpportunities({ panel }) {
  const rows = opportunityRows(panel);
  const count = rows.length;

  // Hooks run unconditionally (before the early return); guard inside.
  useEffect(() => {
    if (panel && count > 0) opportunityShownOnDashboard({ count });
  }, [panel, count]);

  if (!panel) return null; // feature off / no payload → render nothing

  return (
    <section
      data-testid="your-opportunities"
      className="card"
      style={{ display: "grid", gap: "var(--space-3)" }}
    >
      <header style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <h2 style={{ margin: 0 }}>Your Opportunities</h2>
        <span style={{ color: "var(--color-text-muted)", fontSize: "var(--font-size-sm)" }}>
          {panel.active} active
        </span>
      </header>

      <p style={{ margin: 0, color: "var(--color-text-muted)", fontSize: "var(--font-size-sm)" }} data-testid="opportunities-not-advice">
        A signal about your own saved analyses — not investment advice.
      </p>

      {rows.length === 0 ? (
        <p data-testid="opportunities-empty" style={{ margin: 0 }}>
          No opportunities yet. Run an analysis that returns BUY to see it here.
        </p>
      ) : (
        <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: "var(--space-2)" }}>
          {rows.map((o) => (
            <li key={o.opportunity_id} data-testid="opportunity-row">
              <Link
                to={analysisRoute(o.analysis_id)}
                data-testid="opportunity-link"
                onClick={() => opportunityOpened({ opportunity_id: o.opportunity_id, analysis_id: o.analysis_id })}
              >
                {o.label}
                {o.deal_score ? ` — ${o.deal_score}` : ""}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
